module.exports = __webpack_public_path__ + "img/qrcode_xhc.a4f8acb4.jpg";